const users = {
  users: {
    pageHeader: 'Gebruikers',
    addNewUser: '+ Nieuwe gebruiker toevoegen',
    name: 'Naam',
    role: 'Functie',
    company: 'Bedrijf',
    status: 'Status',
    noUser: '** Geen gebruikers beschikbaar **',
    emailMatch: 'Voer dezelfde waarde opnieuw in.',
    validEmail: 'Voer een geldig e-mailadres in.',
    fieldRequired: 'Dit veld is verplicht.',
    userFormHeader: 'Nieuwe gebruikers toevoegen',
    userProfile: 'Gebruikersprofiel',
    defaultEmailHelpText:
      'Er zal een email worden gestuurd naar dit adres, waarin wordt uitgelegd hoe u zich kunt aanmelden.',
    active: 'Actief',
    email: 'E-mail',
    confirmEmail: 'Bevestig e-mail',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    phoneNumber: 'Telefoonnummer',
    preferredLocale: 'Voorkeursland/taal',
    units: 'Eenheden',
    addUser: 'Gebruiker toevoegen',
    updateUser: 'Update Gebruiker',
    supportTechnician: 'Ondersteunende technicus',
    profileAdministrator: 'Profiel Administrator',
    profileApprover: 'Profiel Approver',
    administrator: 'Administrator',
    user: 'Gebruiker',
    viewOnly: 'Alleen bekijken',
    demonstration: 'Demonstratie',
    errorMessageLengthPhone: 'Maximaal 50 tekens toegestaan',
    all: 'Alle',
    inactive: 'Inactief',
    termsAndServices: 'Alleen de eigenaar van het systeem kan toegang verlenen tot de locatie. Zonder schriftelijke toestemming van de eigenaar van het systeem mogen installateurs zich geen toegang verschaffen tot andere bedrijven of toegang verlenen aan gebruikers die zich buiten hun bedrijf bevinden. Ik heb de %{termsService} van Enphase gelezen en ga hiermee akkoord, en ik heb het %{privacyPolicy} van Enphase gelezen. Ik begrijp dat het niet naleven van deze voorwaarden kan leiden tot tijdelijke blokkering of verwijdering van mijn Enlighten-account.',
    privacyPolicy: 'privacybeleid',
    termsService: 'gebruiksvoorwaarden',
  }
};

export default users;
